import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Card, CardContent } from '../ui/card';
import { ClipboardX, ChevronRight } from 'lucide-react';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Journées passées affectées au formateur sans fiche d'émargement validée (heures non comptées au BPF)
export const RappelEmargements = ({ viewAs, refreshKey, onOpen }) => {
  const [manquants, setManquants] = useState([]);
  const [replie, setReplie] = useState(false);
  useEffect(() => {
    axios.get(`${API_URL}/portail/formateur/emargements-manquants`, { params: viewAs ? { view_as: viewAs } : {} }).then(r => setManquants(r.data || [])).catch(() => setManquants([]));
  }, [viewAs, refreshKey]);
  if (manquants.length === 0) return null;
  const visibles = replie ? [] : manquants.slice(0, 12);
  return (
    <Card className="border border-amber-300 bg-amber-50/50" data-testid="formateur-rappel-emargements">
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-3">
          <button type="button" onClick={() => setReplie(r => !r)} className="flex items-center gap-2 text-sm font-semibold text-amber-900" data-testid="rappel-emargements-toggle">
            <ClipboardX className="w-4 h-4" /> Émargements à valider ({manquants.length})
          </button>
          <p className="text-[11px] text-amber-800 text-right max-w-md">Les heures de ces journées ne sont pas comptées dans le bilan pédagogique (BPF) tant que la fiche d'émargement n'est pas validée.</p>
        </div>
        {visibles.length > 0 && (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2 mt-3">
            {visibles.map(m => (
              <button key={`${m.dossier_id}-${m.date}`} type="button" onClick={() => onOpen(m.dossier_id, m.date)} data-testid={`rappel-emargement-${m.dossier_id}-${m.date}`}
                className="flex items-center justify-between gap-2 rounded-lg border border-amber-200 bg-white px-3 py-2 text-left hover:bg-amber-100/60 transition-colors">
                <span className="min-w-0">
                  <span className="block text-xs font-semibold text-slate-800 capitalize">{format(parseISO(m.date), 'EEEE d MMMM yyyy', { locale: fr })}{m.demi_journee !== 'journee' ? <span className="ml-1 text-[10px] font-normal text-slate-500">({m.demi_journee === 'matin' ? 'matin' : 'après-midi'})</span> : null}</span>
                  <span className="block text-[11px] text-slate-500 truncate"><span className="font-mono">{m.type_dossier === 'aft' ? 'AFT · ' : ''}{m.code}</span> · {m.intitule}</span>
                </span>
                <ChevronRight className="w-4 h-4 text-amber-600 shrink-0" />
              </button>
            ))}
          </div>
        )}
        {!replie && manquants.length > 12 && <p className="mt-2 text-[11px] text-amber-800">… et {manquants.length - 12} autre(s) journée(s) plus ancienne(s).</p>}
      </CardContent>
    </Card>
  );
};
